(function () {
  'use strict';

  function sync() {
    if (!(window.innerWidth >= 1024)) return;
    const target = document.querySelector('.product__info-wrapper')
      || document.querySelector('product-info')
      || document.querySelector('.product__info-container');
    const gallery = document.getElementById('tee-gallery');
    if (!target || !gallery) return false;
    const h = Math.round(target.getBoundingClientRect().height);
    if (h > 0) gallery.style.height = h + 'px';
    return true;
  }

  // teeinblue re-renders the preview asynchronously after a variant change, so
  // the new height isn't on the same tick. Re-run sync() across a short window,
  // plus a one-shot ResizeObserver on .tee-gallery-content as a fallback for
  // re-renders that land after the timeouts (disconnects itself after ~1s).
  function resync() {
    requestAnimationFrame(sync);
    setTimeout(sync, 150);
    setTimeout(sync, 400);

    if (!('ResizeObserver' in window)) return;
    const content = document.querySelector('#tee-gallery .tee-gallery-content')
      || document.getElementById('tee-gallery');
    if (!content) return;
    let done = false;
    const ro = new ResizeObserver(function () {
      if (done) return;
      done = true;
      ro.disconnect();
      sync();
    });
    ro.observe(content);
    setTimeout(function () { if (!done) { done = true; ro.disconnect(); } }, 1000);
  }

  let resizeScheduled = false;
  function onResize() {
    if (resizeScheduled) return;
    resizeScheduled = true;
    requestAnimationFrame(function () {
      resizeScheduled = false;
      sync();
    });
  }

  function waitForGallery() {
    if (sync()) return;

    const mo = new MutationObserver(function () {
      if (sync()) mo.disconnect();
    });
    mo.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('load', function () {
      sync();
      mo.disconnect();
    }, { once: true });
  }

  function init() {
    waitForGallery();

    // Refresh the gallery column height whenever the selected variant changes —
    // both the info column and the teeinblue preview can resize, leaving the
    // once-synced inline height on #tee-gallery stale and breaking the sticky
    // scroll. Reuses the theme's pub/sub (same guard other components use).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, resync);
    }

    // Re-sync across the desktop/mobile breakpoint (sync() is a no-op < 1024px).
    window.addEventListener('resize', onResize, { passive: true });
  }

  if (document.readyState === 'loading' || document.readyState === 'interactive') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
